/*
 * 催收机器人
 *
 * */
import { ticketClient } from "@/api/ticketClient";
import { PVDashboardReq, PVGroupStatsReq, ListPhoneVerifyStatsReq, ListPhoneVerifyReasonStatReq } from "@/pbjs/xcommon/ticket_pb";
import { Page, setMetaData } from "@/utils/index";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import InnerRequest from "./request";

//dashboard（页）
export interface Options {
    setUserid?: number,
    Itemid?: string,

}
//工单数据（页）
export interface OptionsTwo {
    Page: Page;
    prop: number;
    order: number;
    Statstype?: number
    Email?: string,
    Username?: string,
    Usergroupid?: string,
    Itemid?: string,
    Timerange?: string,
    Hour?: string,
    IsAll?: boolean,
    AppName?: string,
}
//工单异常统计（页）
export interface OptionsThree {
    Page: Page;
    prop: number;
    order: number;
    Username?: string,
    queryType?: boolean,
    Itemid?: string,
    Timerange?: string,
    Hour?: string,
    IsAll?: boolean,
    AppName?: string,
    isreloan?: boolean,
}

/*------------------------dashboard（获取数据）------------------------ */
export const getPVDashboardRequest = new InnerRequest(
    ticketClient,
    ticketClient.pVDashboard
);
/*------------------------dashboard（pv方法）------------------------ */
export function getPVDashboardReq(arg: Options) {
    let request: any = new PVDashboardReq();

    request.setUserid(arg.setUserid)
    return request;
}

/*------------------------dashboard（获取数据）------------------------ */
export const getPVGroupStatsRequest = new InnerRequest(
    ticketClient,
    ticketClient.pVGroupStats
);
/*------------------------dashboard（pvgroup方法）------------------------ */
export function getPVGroupStatsReq(arg: Options) {
    let request: any = new PVGroupStatsReq();
    request.setUserid(arg.setUserid)
    request.setItemid(arg.Itemid);
    return request;
}

/*------------------------工单数据（列表页获取数据）------------------------ */
export const getListPhoneVerifyStatsRequest = new InnerRequest(
    ticketClient,
    ticketClient.listPhoneVerifyStats
);
/*------------------------工单数据（方法）------------------------ */
export function getListPhoneVerifyStatsReq(arg: OptionsTwo) {
    let request: any = new ListPhoneVerifyStatsReq();
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize, arg.prop, arg.order));
    request.setStatstype(arg.Statstype);
    request.setEmail(arg.Email);
    request.setUsername(arg.Username);
    request.setUsergroupid(arg.Usergroupid);
    request.setItemid(arg.Itemid);
    request.setTimerange(arg.Timerange);
    request.setAppname(arg.AppName);
    request.setIsall(arg.IsAll);
    arg.Hour && request.setHour(arg.Hour)
    return request;
}

/*------------------------工单数据（导出方法）------------------------ */
export function getListPhoneVerifyStatsExcelReq(arg: OptionsTwo, obj: any) {
    return new Promise((resolve, reject) => {
        (async () => {
            let request: any = new ListPhoneVerifyStatsReq();
            request.setCommonin(setCommon());
            request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize, arg.prop, arg.order));
            request.setStatstype(arg.Statstype);
            request.setEmail(arg.Email);
            request.setUsername(arg.Username);
            request.setUsergroupid(arg.Usergroupid);
            request.setItemid(arg.Itemid);
            request.setTimerange(arg.Timerange);
            request.setAppname(arg.AppName);
            request.setIsall(arg.IsAll);
            arg.Hour && request.setHour(arg.Hour)
            // setRank
            let _res = await ticketClient.listPhoneVerifyStatsExcel(
                request,
                setMetaData(),
                (err: any, response: any) => {
                    if (response) {
                        resolve(response);
                    }
                    if (err) {
                        reject(err);
                    }
                }
            );
        })();
    }).then((response: any) => {
        response.loading = false;
        handleResponse(response, null);
        return response;
    }).catch((err: any) => {
        errorMsg(err);
    });     
}

/*------------------------工单异常统计（列表获取数据）------------------------ */
export const getListPhoneVerifyReasonStatRequest = new InnerRequest(
    ticketClient,
    ticketClient.listPhoneVerifyReasonStat
);
/*------------------------工单异常统计（方法）------------------------ */
export function getListPhoneVerifyReasonStatReq(arg: OptionsThree) {
    let request: any = new ListPhoneVerifyReasonStatReq();
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize, arg.prop, arg.order));
    request.setQuerytype(arg.queryType);
    request.setUsername(arg.Username);
    request.setItemid(arg.Itemid);
    request.setTimerange(arg.Timerange);
    request.setAppname(arg.AppName);
    request.setIsall(arg.IsAll);
    request.setIsreloan(arg.isreloan);
    return request;
}

/*------------------------工单异常统计（导出列表数据）------------------------ */
export function getListPhoneVerifyReasonStatExcelReq(arg: OptionsThree, obj: any) {
    return new Promise((resolve, reject) => {
        (async () => {
            let request: any = new ListPhoneVerifyReasonStatReq();
            request.setCommonin(setCommon());
            request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize, arg.prop, arg.order));
            // request.setQuerytype(arg.queryType);
            request.setQuerytype(arg.queryType);
            request.setUsername(arg.Username);
            request.setIsreloan(arg.isreloan);
            request.setItemid(arg.Itemid);
            request.setTimerange(arg.Timerange);
            request.setAppname(arg.AppName);
            request.setIsall(arg.IsAll);
            // setRank
            let _res = await ticketClient.listPhoneVerifyReasonStatExcel(
                request,
                setMetaData(),
                (err: any, response: any) => {
                    if (response) {
                        resolve(response);
                    }
                    if (err) {
                        reject(err);
                    }
                }
            );
        })();
    }).then((response: any) => {
        response.loading = false;
        handleResponse(response, null);
        return response;
    }).catch((err: any) => {
        errorMsg(err);
    });      
}

